import React from 'react'

const Home = () => {
  return (
    <div style={{justifyContent: 'center', alignItems: 'center'}}>
        <button style={{backgroundColor: "green", color: "white", padding: '5px', borderRadius: '5px'}}>Get Started</button>
    </div>
  )
}


export default Home